<table>
  <thead>
  <tr>
    <th class="avtalenavn">{{ "Avtalenavn" | translate }}</th>
    <th class="organisasjonsnavn">{{ "Organisasjonsnavn" | translate }}</th>
    <th class="gruppetittel">{{ "Gruppetittel" | translate }}</th>
    <th class="møtenavn">{{ "Møtenavn" | translate }}</th>
  </tr>
  </thead>
  <tbody>
    @for (gruppe of grupper; track gruppe) {
      <tr>
        <td class="avtalenavn">{{ gruppe.avtalenavn }}</td>
        <td class="organisasjonsnavn">{{ gruppe.organisasjonsnavn }}</td>
        <td class="gruppetittel">{{ gruppe.tittel }}</td>
        <td class="møtenavn">{{ gruppe.moetenavn }}</td>
      </tr>
    }
  </tbody>
  <tfoot>
  <tr>
    <td colspan="4">
      <mat-paginator #paginator
                     [pageSizeOptions]="[25,50,100,200,500]"
                     (page)="handlePageEvent($event)"
                     [showFirstLastButtons]="true"
                     [pageSize]="sideStoerrelse"
      >
      </mat-paginator>
    </td>
  </tr>
  </tfoot>
</table>
